export default "__VITE_ASSET__BXjhjqXg__"